exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form{\r\n    border-radius: 10px;\r\n    box-shadow: 0px 10px 15px rgba(138, 87, 231, 0.1);\r\n    background: #fbf7f854;\r\n  \r\n}\r\n.bg{\r\n    width:100%;\r\n    height:100%; \r\n    position:fixed;\r\n    background-image: url(/assets/img/bglogin.jpg);\r\n    background-repeat: no-repeat;\r\n    background-position: center\r\n}\r\n.bg2{ \r\n    -webkit-backdrop-filter: grayscale() blur(15px); /* Safari 9+ */\r\n    backdrop-filter: grayscale() blur(15px); /* Chrome and Opera */\r\n    width:100%;\r\n    height:100%; \r\n    position:fixed;\r\n    background-color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/project_chips/xosotravinh/xosotravinh_angular_client/src/app/login/login.component.css
// module id = ../../../../../src/app/login/login.component.css
// module chunks = main